module.exports = __webpack_public_path__ + "static/eco-travels-09508d0028371921b127fdee83ecfe0a.png";